var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-nav-logo-links",class:_vm.logoTabs.tabBorderColorClass},[(
      _vm.logoTabs.logo1.url &&
        _vm.logoTabs.logo1.url.length &&
        _vm.logoTabs.logo1.imgUrl.length
    )?_c('a',{staticClass:"mobile-nav-logo-links__link",attrs:{"href":_vm.logoTabs.logo1.url}},[_c('img',{staticClass:"mobile-nav-logo-links__image",attrs:{"src":_vm.logoTabs.logo1.imgUrl}})]):_vm._e(),(
      _vm.logoTabs.logo2.url &&
        _vm.logoTabs.logo2.url.length &&
        _vm.logoTabs.logo2.imgUrl.length
    )?_c('a',{staticClass:"mobile-nav-logo-links__link",attrs:{"href":_vm.logoTabs.logo2.url}},[_c('img',{staticClass:"mobile-nav-logo-links__image",attrs:{"src":_vm.logoTabs.logo2.imgUrl}})]):_vm._e(),(
      _vm.logoTabs.logo3.url &&
        _vm.logoTabs.logo3.url.length &&
        _vm.logoTabs.logo3.imgUrl.length
    )?_c('a',{staticClass:"mobile-nav-logo-links__link",attrs:{"href":_vm.logoTabs.logo3.url}},[_c('img',{staticClass:"mobile-nav-logo-links__image",attrs:{"src":_vm.logoTabs.logo3.imgUrl}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }